// Vuetify 3 + Vue 3 plugin setup
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "@mdi/font/css/materialdesignicons.css";

// Define your custom theme
const customTheme = {
  dark: false, // REQUIRED
  colors: {
    primary: "#1C7C80",
    secondary: "#6c757d",
    success: "#125a87",
    warning: "#c6269e",
    error: "#b00020",
    info: "#6c757d",
    whitecolor: "#ffffff",
    darkplum: "#3a1246",
    colorteal600: "#1c7c80",
    colornavy600:"#334155"
    //background: "#f5f5f5ff",
    //surface: "#f4efecff",
  },
};

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "light",
    themes: {
      light: customTheme,
      dark: { ...customTheme, dark: true },
    },
  },
  icons: {
    defaultSet: "mdi",
  },
});
